import React, { useState, useEffect, useRef, useCallback } from 'react'
import { CompanyObject } from '../../../../../generated/graphql'
import { getAuth } from '../../../../modules/auth/core/AuthHelpers'

type Props = {
  companyData: CompanyObject
}

export const TasksViewWrapper = ({ companyData }: Props) => {
  const [refreshKey, setRefreshKey] = useState(0)
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const iframeWindowRef = useRef<Window | null>(null)
  const auth = getAuth()

  const refreshIframe = useCallback(() => {
    setRefreshKey((prevKey) => prevKey + 1)
  }, [])

  const companyType = companyData.type === 'HISSA' ? 'HISSA' : 'INVESTOR'
  const companyId = companyData.hissaCompanyId || companyData.id

  useEffect(() => {
    refreshIframe()

    if (iframeRef.current) {
      iframeWindowRef.current = iframeRef.current.contentWindow
    }

    return () => {
      if (iframeWindowRef.current) {
        iframeWindowRef.current.postMessage(
          { type: 'UNMOUNT', message: 'Parent component is unmounting' },
          process.env.REACT_APP_TASKMANAGER_CLIENT_URL! // Target origin for security
        )
      }
    }
  }, [refreshIframe])

  return (
    <div className='row m-0'>
      <div className='card'>
        <div className='card-body p-0' style={{ scrollbarWidth: 'none' }}>
          <div className='row' style={{ overflow: 'hidden', height: 'calc(100vh - 110px - 45px)' }}>
            <iframe
              key={refreshKey}
              ref={iframeRef}
              src={`${
                process.env.REACT_APP_TASKMANAGER_CLIENT_URL
              }/invPortal/myTasks/${companyType}/${companyId}/${auth!}`}
              title='Task Manager'
              loading='eager'
              width='100%'
              style={{ border: 'none', height: '100%', padding: 0, overflow: 'auto' }}
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  )
}
